import { squareConnectSsoFacade } from '../facades';

export const squareSsoConnectCallback = ({ code, state }): Promise<void> => squareConnectSsoFacade.callback(code, state);
